export const DATA_IDS = {
  PEER_CONFIG_MODAL: 'PeerConfigModal',
  PEER_CONFIG_ADD_PEERS_INPUT: 'PeerConfigAddPeersInput',
  PEER_CONFIG_ADD_PEERS_MENU: 'PeerConfigAddPeersMenu',
  PEER_CONFIG_CANCEL_BUTTON: 'PeerConfigCancelButton',
  PEER_CONFIG_UPDATE_BUTTON: 'PeerConfigUpdateButton'
}
